import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line css-modules/no-unused-class
import postStyles from '../styles/posts.module.css';
export interface PostTitleProps {
	// post: Post | FullPost;
	children?: React.ReactNode;
	postId?: string;
	className?: string;
}
/**
 * PostTitle component
 * @param { PostTitleProps } props component props
 * @returns { JSX.Element } rendered post title
 */
export function PostTitle({ children, postId, className }: PostTitleProps) {
	return (
		<div className={classNames(postStyles.postTitle, className)} data-testid={`PostTitle-${postId}`}>
			{children}
		</div>
	);
}
